import { firestore, auth } from "../api/firebase";
import createDataContext from "./createDataContext";

const pointsReducer = (state, action) => {
  switch (action.type) {
    case "set_claimed":
      return { ...state, claimed: action.payload };
    case "set_loading":
      return { ...state, loading: action.payload };
    case "set_claims":
      return { ...state, claims: action.payload };
    case "set_given":
      return { ...state, given: action.payload };
    default:
      return state;
  }
};

const ensureFreshAdminToken = async () => {
  try {
    const user = auth.currentUser;
    if (user) {
      await user.getIdToken(true);
    }
  } catch (_) {}
};

const fetchClaims = (dispatch) => async () => {
  dispatch({ type: "set_loading", payload: true });
  const claimsFetch = [];

  try {
    await ensureFreshAdminToken();
    const snapshot = await firestore
      .collection("claims")
      .orderBy("timestamp", "desc")
      .limit(10000)
      .get();

    snapshot.forEach((doc) => {
      let claim = { id: doc.id, ...doc.data() };
      claim.timestamp = claim.timestamp.toDate().toString().split("GMT")[0];
      claimsFetch.push(claim);
    });
    dispatch({ type: "set_claims", payload: claimsFetch });
  } catch (_) {
    // Silenciar primer intento cuando el token aún no refleja admin
  } finally {
    dispatch({ type: "set_loading", payload: false });
  }
};

const fetchIndicators = (dispatch) => async () => {
  try {
    await ensureFreshAdminToken();
    let response = await firestore.collection("points").doc("claimed").get();
    dispatch({ type: "set_claimed", payload: { ...response.data() } });

    response = await firestore.collection("points").doc("given").get();
    dispatch({ type: "set_given", payload: { ...response.data() } });
  } catch (_) {
    // Ignorar primer fallo por token; el usuario puede refrescar o reintentar
  }
};

export const { Provider, Context } = createDataContext(
  pointsReducer,
  { fetchClaims, fetchIndicators },
  {
    claims: [],
    loading: false,
    claimed: {},
    given: {},
    validScopes: ["otorgados", "canjeados"],
  }
);
